import { request } from '@api/request'
import { WeatherData } from '@models/api/SymbolMap'
import { Model } from '@models/Model'
import { TDateISODateFormat } from '@services/DateService'
import { Dayjs } from 'dayjs'

export const symbolMap = {
  getData: function (model: Model, variableID: string, selectedOut?: Dayjs) {
    return request.get<WeatherData>('variables/getWeatherIcons', {
      params: {
        model: model.id,
        date:
          selectedOut?.format(TDateISODateFormat) ??
          model.getDate().format(TDateISODateFormat),
        out: selectedOut?.utc().format('HH') ?? model.out,
        variable: variableID
      }
    })
  }
}
